<template>
  <div id="stepper-wrapper" class="col" data-cy="sidestepper-container">
    <router-link
      v-for="step in steps"
      v-show="!(step.id === 3 && clinicSpecific) && step.id !== 5"
      :key="step.id"
      :class="
        step.id < actual
          ? 'step completed'
          : step.id === actual
          ? 'step active'
          : 'step'
      "
      :to="
        step.name && step.id < actual
          ? { name: `${type}_${step.name}`, params: {} }
          : {}
      "
      :data-cy="`sidestepper-step-${step.id}`"
    >
      <div class="v-stepper" data-cy="sidestepper-vstepper">
        <div class="circle" data-cy="sidestepper-circle">
          <div class="caption" data-cy="sidestepper-caption">
            {{ displayStep(step.id) }}
          </div>
        </div>
        <div
          v-if="steps.length !== step.id"
          class="line"
          data-cy="sidestepper-line"
        ></div>
      </div>

      <div class="content text-truncate" data-cy="sidestepper-content">
        {{ step.description }}
        <div class="selection text-truncate" data-cy="sidestepper-selection">
          {{ selected[step.id - 1] ? selected[step.id - 1].nome : "" }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "side-stepper",
  props: ["actual", "steps"],
  methods: {
    displayStep(value) {
      let step = value;
      if (this.clinicSpecific && value > 3) {
        step--;
      }

      if (value > 4) {
        step--;
      }

      return step;
    }
  },
  computed: {
    type() {
      return this.$store.getters.type;
    },
    clinicSpecific() {
      return this.$store.getters.clinicSpecific;
    },
    selected() {
      return this.$store.getters.get_selected;
    }
  }
};
</script>

<style scoped>
a.step,
a.step:hover {
  text-decoration: none !important;
}
</style>
